import React from 'react';
import { BsBellFill } from 'react-icons/bs';
import { IconButton, Box } from '@chakra-ui/react';
import { CustomNotificationProps } from '../../types/ui';

export default function CustomNotification (props: CustomNotificationProps) {
    return (
        <Box className='notification--wrap mr--10'>
            <IconButton 
                aria-label='Notifications' 
                colorScheme={'gray'}
                fontSize='20px'
                icon={<BsBellFill aria-label='Bell icon'  />} 
                size='sm'
                variant={'ghost'}
                className='mr--10'
            />
            <Box className='notification--badge' />
        </Box>
    )
}